import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Bindi } from "@/components/motifs";
import { ARTIST } from "@/lib/constants";
import { PAGES } from "@/lib/site";

export default function NotFound() {
  return (
    <div data-testid="not-found-page">
      <Seo title={`Page not found — ${ARTIST.name}`} siteName={ARTIST.name} robots="noindex, follow" />
      <Navbar />
      <main className="mx-auto flex max-w-3xl flex-col items-center gap-6 px-5 pb-32 pt-44 text-center sm:px-8">
        <Bindi size={10} pulse />
        <h1 className="font-serif text-4xl font-semibold tracking-tight sm:text-5xl">This page could not be found.</h1>
        <p className="max-w-lg text-muted-foreground">
          The link may be old, or the work may have moved. Continue to the gallery or return home.
        </p>
        <div className="mt-4 flex flex-wrap justify-center gap-4">
          <Link
            to={PAGES.gallery.path}
            className="rounded-full bg-foreground px-7 py-3.5 text-[13px] font-semibold tracking-wide text-background transition-colors duration-300 hover:bg-accent hover:text-accent-foreground"
          >
            Visit the Gallery
          </Link>
          <Link
            to="/"
            className="rounded-full border border-foreground/30 px-7 py-3.5 text-[13px] font-semibold tracking-wide transition-colors duration-300 hover:border-accent hover:text-accent"
          >
            Return Home
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
